import { jsx } from 'react/jsx-runtime';
import StripeProvider from '../stripe-provider/StripeProvider.js';
var PaymentProvider = function PaymentProvider(_ref) {
  var amount = _ref.amount,
    paymentMethodType = _ref.paymentMethodType,
    isStubbed = _ref.isStubbed,
    renderLoadingIndicator = _ref.renderLoadingIndicator,
    renderPaymentButton = _ref.renderPaymentButton,
    stripeConfig = _ref.stripeConfig;
  var _ref2 = stripeConfig || {},
    publishableKey = _ref2.publishableKey,
    stripeAccount = _ref2.stripeAccount;
  var shouldRender = isStubbed || publishableKey && stripeAccount;
  if (!shouldRender) return null;
  return jsx(StripeProvider, {
    amount: amount,
    isStubbed: isStubbed,
    paymentMethodType: paymentMethodType,
    renderLoadingIndicator: renderLoadingIndicator,
    renderPaymentButton: renderPaymentButton,
    stripeConfig: stripeConfig
  });
};
export { PaymentProvider as default };